'use client';

import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

const CheckGroup = ({ field, formData, dictionaries, handleFieldChange }) => {
  const handleCheckboxChange = (value) => {
    const current = formData[field.name] || [];
    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];

    handleFieldChange(updated);
  };

  const dict = dictionaries?.[field.dictionary];
  if (!dict) {
    return null;
  }

  return (
    <div className="mb-4">
      {field.label && <Form.Label>{field.label}</Form.Label>}

      {field.singleGroup === true ? (
        dict.length === 0 ? (
          <div className="text-muted mt-2">
            Brak opcji dostępnych do wyboru, skonfiguruj w ustawieniach.
          </div>
        ) : (
          <Row className="mt-2">
            {dict.map((opt) => (
              <Col key={opt.id} xs={12} sm={6} lg={4}>
                <Form.Check
                  className="mb-3 custom-checkbox custom-checkbox-lg"
                  type="checkbox"
                  label={opt.name}
                  name={opt.id}
                  id={`single-${opt.id}`}
                  checked={(formData[field.name] || []).includes(opt.id)}
                  onChange={() => handleCheckboxChange(opt.id)}
                />
              </Col>
            ))}
          </Row>
        )
      ) : (
        dict.map((group) => {
          const options = group[field.dictionaryListField];
          if (!options || options.length === 0) return null;

          return (
            <Form.Group className="mb-4" key={group.name}>
              <Form.Label className="fw-semibold fs-5">{group.name}</Form.Label>
              <Row className="mt-4">
                {options.map((opt) => (
                  <Col key={opt.id} xs={12} sm={6} lg={4}>
                    <Form.Check
                      className="mb-3 custom-checkbox custom-checkbox-lg"
                      type="checkbox"
                      label={opt.name}
                      name={opt.id}
                      id={`${group.name}-${opt.id}`}
                      checked={(formData[field.name] || []).includes(opt.id)}
                      onChange={() => handleCheckboxChange(opt.id)}
                    />
                  </Col>
                ))}
              </Row>
            </Form.Group>
          );
        })
      )}
    </div>
  );
};

export default CheckGroup;
